import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

/**
 * The trail above a page title, naming the space rather than the word "space".
 *
 * Which space you are in is the one piece of context every page below it
 * needs, and the corpus screen in particular reads as everything you own
 * without it.
 */
export function Crumbs({ spaceId, children }: { spaceId: string; children?: React.ReactNode }) {
  // Shared cache key with the space page, so arriving from there costs nothing
  // and arriving directly still fills in.
  const space = useQuery({
    queryKey: ["space", spaceId],
    queryFn: () => api.getSpace(spaceId as never),
  });

  return (
    <p className="crumb">
      <Link to="/spaces">Spaces</Link>
      {" · "}
      <Link to={`/spaces/${spaceId}`}>
        {/* The name once it is known, and the word until then, so the trail
            does not change width and shove the title around as it loads. */}
        {space.data?.name ?? "Space"}
      </Link>
      {children}
    </p>
  );
}
